import React, { useState, useEffect, useContext } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  MenuItem,
} from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import baseUrl from "../../../../BaseURL";
import { ContextData } from "../../../../context/Context";




function UploadDocumentSettings() {


  const { accesstoken,UserTokens } = useContext(ContextData);

  // Form State
  const [formData, setFormData] = useState({
    file_name: "",
    instructions: "",
    action: "",
    file: null,
    loan_category: ""
  });

  // Uploaded Files List
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [reload, setReload] = useState(false);

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle File Selection
  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  // Upload File
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.file_name || !formData.instructions || !formData.action || !formData.file) {
      toast.error("Please fill in all fields and select a file.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("file_name", formData.file_name);
    formDataToSend.append("instructions", formData.instructions);
    formDataToSend.append("action", formData.action);
    formDataToSend.append("file", formData.file);
    formDataToSend.append("file", UserTokens);
    formDataToSend.append("loan_category", formData.loan_category);


    try {
      const response = await axios.post(`${baseUrl}/auth/upload_file_sett`, formDataToSend, {
        withCredentials: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accesstoken}`,
        },
      });

      if (response.data.status) {
        toast.success("File uploaded successfully!");
        setFormData({ file_name: "", instructions: "", action: "", file: null });
        setReload(!reload);
      } else {
        toast.error(response.data.textStatus || "Upload failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error uploading file.");
    }
  };

  // Fetch Uploaded Files
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get(`${baseUrl}/auth/get_uploaded_files_settings`, {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${accesstoken}`,
          },
        });
        setUploadedFiles(response.data);
       // setUploadedFiles([]);
      } catch (err) {
        console.error(err.message);
      }
    }
    fetchData();
  }, [reload]);

  // Delete Uploaded File
  const handleDelete = async (file_token) => {
    try {
      const response = await axios.delete(`${baseUrl}/auth/delete_uploaded_file/${file_token}`, {
        withCredentials: true,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accesstoken}`,
        },
      });
      toast.warn(response.data.textStatus || "File deleted.");
      setReload(!reload);
    } catch (err) {
      console.error(err.message);
      toast.error("Error deleting file.");
    }
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Upload File</h2>

      <form className="space-y-4 text-left" onSubmit={handleSubmit}>
        <TextField
          label="File Name"
          name="file_name"
          value={formData.file_name}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

            <TextField
            select
            label="Loan Category"
            name="loan_category"
            value={formData.loan_category}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
            >
            <MenuItem value="studentloan">STUDENT TERTIARY EDUCATION LOAN</MenuItem>
            <MenuItem value="thirdparty">STUDENT TERTIARY EDUCATION LOAN ( Third-Party Guarantee )</MenuItem>
            </TextField>

        <TextField
          label="Instructions"
          name="instructions"
          value={formData.instructions}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          multiline
          rows={3}
        />

        <TextField
          label="Action"
          name="action"
          value={formData.action}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />

        <Button variant="contained" component="label">
          Choose File
          <input type="file" hidden onChange={handleFileChange} />
        </Button>
        {formData.file && (
          <div className="text-sm text-gray-600 mt-1">{formData.file.name}</div>
        )}

        <Button type="submit" variant="contained" color="primary" className="w-full">
          Submit
        </Button>
      </form>

      {/* Uploaded Files Table */}
      <div className="mt-6">
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "rgb(0, 24, 69)" }}>
              <TableRow>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>No.</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>File Name</TableCell>
                 <TableCell sx={{ color: "white", fontWeight: "bold" }}>loanCategory</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Instructions</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>File</TableCell>
                <TableCell sx={{ color: "white", fontWeight: "bold" }}>Remove</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {uploadedFiles.length > 0 ? (
                uploadedFiles.map((file, index) => (
                  <TableRow key={file.file_token || index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{file.file_name}</TableCell>
                    <TableCell>{file.loan_category}</TableCell>
                    <TableCell>{file.instructions}</TableCell>
                    <TableCell>{file.action}</TableCell>
                    <TableCell>
                      <a
                        href={file.file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "blue", textDecoration: "underline" }}
                      >
                        View
                      </a>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => handleDelete(file.file_token)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No files uploaded yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default UploadDocumentSettings;
